const initialState = {
  userInfo: null,
  error: null
}

// Action Types
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_ERROR = 'SET_ERROR'

// Action Creators
export const setUserInfo = () => ({
  type: SET_USER_INFO
})
export const setError = (error) => ({
  type: SET_ERROR,
  payload: error
})

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_INFO:
      return {
        ...state,
        userInfo: action.payload
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default userReducer
